import { Request as request } from "@/utils/request";

/**
 * KV Cache API - 跨设备同步的键值存储
 * tier: "session"(Redis, 7天TTL自动刷新) | "account"(MySQL, 永久)
 */

/**
 * 全量获取 session + account 所有数据
 * 登录/刷新后调用一次，后续读操作零网络开销
 * @returns {Promise<{ code, data: { session: Object, account: Object } }>}
 */
export const kvGetAll = () => {
  return request("/api/kv/all");
};

/**
 * 写入/更新单个 KV
 * @param {string} key
 * @param {any} value - 任意 JSON 类型，最大 16KB
 * @param {{ tier?: string }} options
 */
export const kvSet = (key, value, { tier = "account" } = {}) => {
  return request(`/api/kv/${key}`, {
    method: "PUT",
    params: { value, tier },
  });
};

/**
 * 批量写入 KV
 * @param {Object} items - { key: value } 对象，最多 50 个
 * @param {{ tier?: string }} options
 */
export const kvSetBatch = (items, { tier = "account" } = {}) => {
  return request("/api/kv/batch", {
    method: "PUT",
    params: { items, tier },
  });
};

/**
 * 读取单个 KV
 * @param {string} key
 * @param {string} tier - "session" | "account"
 */
export const kvGet = (key, tier = "account") => {
  return request(`/api/kv/${key}?tier=${tier}`);
};

/**
 * 删除 KV
 * @param {string} key
 * @param {string} tier
 */
export const kvDel = (key, tier = "account") => {
  return request(`/api/kv/${key}?tier=${tier}`, {
    method: "DELETE",
  });
};

/**
 * 列出所有 account 层 key
 */
export const kvKeys = () => {
  return request("/api/kv");
};
